<template>
    <div>
        <div class="py-3" style="">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <h1 class="d-flex justify-content-center">Submitted / Paid Reports</h1>
                    </div>
                </div>
            </div>
        </div>
        <div class="py-5">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <input type="text" v-model="searchQuery" placeholder="Search..." class="form-control mb-3" />
                        <b-spinner class="center-spinner" v-if="!loaded" variant="primary" label="Spinning"></b-spinner>
                        <b-table v-if="loaded" striped hover :items="filteredReports" :show-empty="true" empty-text="There are no records to show"
                                 :fields="fields"
                                 :sort-by.sync="sortBy"
                                 :sort-desc.sync="sortDesc"
                                 :sort-compare="customSort"
                                 responsive="sm"
                        >
                            <template v-slot:cell(ReportName)="data">
                                <span v-html="data.value"></span>
                            </template>
                            <template v-slot:cell(SubmittedDate)="data">
                                {{data.value | formatDate}}
                            </template>
                            <template v-slot:cell(PaidDate)="data">
                                {{data.value | formatDate}}
                            </template>
                            <template v-slot:cell(ReimbursementTotal)="data">
                                {{data.value | currency}}
                            </template>
                        </b-table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ReportService from '@/services/ReportService'

    export default {
        async created() {
            this.loadReports();
        },
        data() {
            return {
                response: null,
                loaded: false,
                searchQuery: '',
                sortBy: 'SubmittedDate',  // Default sort column
                sortDesc: false,          // Default sort order (ascending)
                fields: [
                    { key: 'SubmittedDate', label: 'Submitted Date', sortable: true },
                    { key: 'PaidDate', label: 'Paid Date', sortable: true },
                    { key: 'Approvals', label: 'Approvals', sortable: false },
                    { key: 'ReportName', label: 'Report Name', sortable: true },
                    { key: 'Project', label: 'Project', sortable: true },
                    { key: 'Type', label: 'Type', sortable: true },
                    { key: 'Status', label: 'Status', sortable: true },
                    { key: 'ReimbursementTotal', label: 'Reimbursement Total', sortable: true }
                ]
            }
        },
        computed: {
            // Filter reports based on the search query
            filteredReports() {
                if (!this.searchQuery) {
                    return this.response; // Return all reports if no search query is provided
                }

                return this.response.filter(report => {
                    console.log(report)
                    // Convert searchQuery to lowercase for case-insensitive search
                    const query = this.searchQuery.toLowerCase();

                    // Strip HTML tags from ReportName
                    const strippedReportName = report.ReportName ? report.ReportName.replace(/(<([^>]+)>)/gi, "").toLowerCase() : '';

                    const submittedDate = report.SubmittedDate ? report.SubmittedDate.format('MM/DD/YYYY') : '';
                    const paidDate = report.PaidDate ? report.PaidDate.format('MM/DD/YYYY') : '';

                    const reimbursementTotal = report.ReimbursementTotal || 0;
                    const queryAsNumber = parseFloat(this.searchQuery);

                    return (
                        strippedReportName.includes(query) ||
                        report.Project && report.Project.toLowerCase().includes(query) ||
                        report.Type && report.Type.toLowerCase().includes(query) ||
                        report.Status && report.Status.toLowerCase().includes(query) ||
                        report.Approvals && report.Approvals.toLowerCase().includes(query) ||
                        submittedDate.includes(query) || 
                        paidDate.includes(query) ||  
                        (!isNaN(queryAsNumber) && reimbursementTotal === queryAsNumber) 
                    );
                });
            }
        },
        methods: {
            async loadReports() {
                this.loaded = false;
                this.response = await ReportService.getPaidReports();
                this.loaded = true;
            },

            // seems to give the actual date rather than string in this function so it should have worked without this function
            customSort(itemA, itemB, key) {
                if (key === 'SubmittedDate' || key === 'PaidDate') {
                    let a = itemA[key]
                    let b = itemB[key]
                    // Return the comparison result
                    return a - b
                } else if (key === 'ReportName') {
                    let a = itemA[key] ? itemA[key].replace(/(<([^>]+)>)/gi, "").toLowerCase() : '';
                    let b = itemB[key] ? itemB[key].replace(/(<([^>]+)>)/gi, "").toLowerCase() : '';
                    console.log(a)
                    // Return the comparison result
                    return a.localeCompare(b)
                } else {
                    // If field is not `date` we let b-table handle the sorting
                    return false
                }
            }
        }
    }
</script>

